<template>
<div class="tab-content" v-if="isActive">
	<slot></slot>
</div>
</template>

<script>
export default {
	props: {
		name: {
			required: true
		},
		selected: {
			default: false
		},
		anchor: {
            default: null
		}
	},

	data() {
		return {
			isActive: this.selected
		};
	},

	computed: {
		href() {
		    if (this.anchor != null) return '#' + this.anchor;
			return '#' + this.name.toLowerCase().replace(/ /g, '-');
		}
	},
    watch: {
        selected: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            handler (val, oldVal) {
                // do your stuff
				this.isActive = val;
				this.$emit('change', true)
            }
        }
    }
}
</script>
